import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../styles/Layout.scss";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAcademyPage = location.pathname === "/academy";

  return (
    <div className={`layout ${isAcademyPage ? "academy-layout" : ""}`}>
      <div className="header-wrapper">
        <Header />
      </div>
      <main>{children}</main>
      <Footer isAcademyPage={isAcademyPage} />
    </div>
  );
};

export default Layout;
